import i18n from './i18n';

export default {
  title: i18n.t('app.title'),
  feBuildNum: '80'
};
